import { render } from "./oldlist.vue?vue&type=template&id=1b68dfd4&scoped=true"
import script from "./oldlist.vue?vue&type=script&lang=js"
export * from "./oldlist.vue?vue&type=script&lang=js"

import "./oldlist.vue?vue&type=style&index=0&id=1b68dfd4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b68dfd4"

export default script